export const ECOG_FIT_TOP = 2;
export const AGE_DIFF = 5;
export const ADULT_MIN_AGE = 18;

export const EMPTY_ELIGIBILITY_AC_CRITERIA = {
  'ECOG status': '',
  Gleason: '',
  DiseaseWithinProstate: null,
  DiseaseOutsideProstate: null,
};

// AC: acceptance criteria
export const acceptanceCriteria = {
  RECRUITING: 'Recruiting',
  UN_KNOWN_STATUS: 'Unknown status',
  UK: 'United Kingdom',
};

export const EligibilityCriteria = {
  ECOGStatus: 'ECOG status',
  Gleason: 'Gleason',
  DiseaseWithinProstate: 'DiseaseWithinProstate',
  DiseaseOutsideProstate: 'DiseaseOutsideProstate',
};
